import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm-stop',
  templateUrl: './confirm-stop.component.html',
  styleUrls: ['./confirm-stop.component.scss']
})
export class ConfirmStopComponent implements OnInit {
  @Input() routeName: string;
  @Output() onConfirmStop = new EventEmitter<void>();
  @Output() onCancelStop = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  confirmStop(): void {
    this.onConfirmStop.emit();
  }

  cancelStop(): void {
    this.onCancelStop.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/confirm-stop/confirm-stop.component.ts